module.exports = require('./code').default
